// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5316":"e02aaf40","43737":"fb7d5399","56163":"dadd2f00"}[chunkId] || chunkId) + "." + {"5316":"5e96de649c889e7c","13477":"95f3d0ce52de4500","43737":"3c7474224ee9d407","56163":"05f4fa7fb5f03919","65074":"02fc7494f9248873"}[chunkId] + ".js";
};